import { TableRowData } from 'tdesign-react';
/**
 * 表格编辑列排序
 */
export const sortByEditIndex = (a: TableRowData, b: TableRowData) => {
  if (a.editIndex <= b.editIndex) {
    return -1;
  }
  if (a.editIndex > b.editIndex) {
    return 1;
  }
  return 0;
};
